import { Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment';
import alloy from '@alloyidentity/web-sdk';

type AlloyInitParams = {
  key: string;
  production: boolean;
  journeyToken?: string;
  journeyApplicationToken?: string;
};

type AlloyInitResponse = {
  threatmetrixSessionId?: string;
  threatmetrix_session_id?: string;
  alloyRequestFields?: Record<string, string | boolean>;
};

@Injectable({
  providedIn: 'root'
})


export class AlloyService {
  constructor() { }
private tmxSessionId: string | null = null;
  private alloyInitPromise: Promise<string | null> | null = null;

  initAlloyOnce(): Promise<string | null> {
    if (this.alloyInitPromise) {
      return this.alloyInitPromise;
    }

    const alloyConfig = environment.alloy;

    const initPayload: AlloyInitParams = {
      key: alloyConfig.sdkKey,
      production: alloyConfig.production
    };

    if (alloyConfig.journeyToken) {
      initPayload.journeyToken = alloyConfig.journeyToken;
    }

    if (alloyConfig.journeyApplicationToken) {
      initPayload.journeyApplicationToken =
        alloyConfig.journeyApplicationToken;
    }

    this.alloyInitPromise = alloy
      .init(initPayload)
      .then((response: AlloyInitResponse) => {
        const rawTmxId =
          response?.threatmetrixSessionId ??
          response?.threatmetrix_session_id ??
          response?.alloyRequestFields?.['threatmetrixSessionId'] ??
          response?.alloyRequestFields?.['threatmetrix_session_id'] ??
          null;

        const tmxId =
          typeof rawTmxId === 'string' ? rawTmxId : null;

        this.tmxSessionId = tmxId;

        return tmxId;
      })
      .catch((error) => {
        console.error('[AlloyService] init failed:', error);

        this.alloyInitPromise = null;
        this.tmxSessionId = null;

        return null;
      });

    return this.alloyInitPromise;
  }

  getTmxSessionId(): string | null {
    return this.tmxSessionId;
  }

  resetAlloyInit(): void {
    this.alloyInitPromise = null;
    this.tmxSessionId = null;
  }
}
